import React from 'react';
import logger from 'shared-kernel/logger';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, stack: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(err, info) {
        logger.e(err);

        this.setState(p => ({
            ...p,
            error: err.toString(),
            stack: info.componentStack
        }));
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='w-100vw h-100vh bc-e1 c-e6 p-4 d-l ff-m'>
                    <div>{this.state.error}</div>
                    {this.state.stack.split('\n').map((x, i) => <div key={i} children={x} />)}
                </div>
            );
        }

        return this.props.children;
    }
}